export default __webpack_public_path__ + "static/media/4.ef71227c.png";